<template>
  <Layout>
    <PageHeader :title="title" :items="itemsPageHeader" />
    <b-row>
      <b-col cols="12">
        <b-card class="mb-2">
          <b-row>
            <b-col cols="6">
              <b-form-group label="Search" label-cols="3">
                <b-form-input
                  v-model="filter.keyword"
                  placeholder="id / Exception / Message"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Log date" label-cols="3">
                <date-picker
                  v-model="filter.DateTime"
                  placeholder="Select date range"
                  :format="'DD/MM/YYYY'"
                  :type="'date'"
                  range
                  confirm
                  @confirm="onDatePickerConfirm()"
                  @clear="onDatePickerClear()"
                ></date-picker>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Status" label-cols="3">
                <b-form-checkbox
                  class="d-inline mr-2"
                  v-model="allSelected"
                  :indeterminate="indeterminate"
                  aria-describedby="flavours"
                  aria-controls="flavours"
                  @change="toggleAll"
                >
                  All
                </b-form-checkbox>
                <b-form-checkbox-group
                  class="p-1 d-inline"
                  v-model="filter.Status"
                >
                  <b-form-checkbox value="Resent">
                    Resent (ส่งแล้ว)
                  </b-form-checkbox>
                  <b-form-checkbox value="None">None</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Type" label-cols="3">
                <multiselect
                  v-model="filter.Exchange"
                  :options="exchangeTypes"
                  placeholder="Select one type"
                  :custom-label="namingType"
                  :show-labels="false"
                >
                </multiselect>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-button-toolbar
                aria-label="Toolbar with button groups and dropdown menu"
                class="d-flex justify-content-end"
              >
                <b-button variant="primary" @click="onSearchClicked()">
                  <i class="fas fa-search"></i> Search
                </b-button>
                <b-button variant="light" @click="onResetClicked()">
                  <i class="fas fa-redo"></i> Reset
                </b-button>
              </b-button-toolbar>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="12">
        <b-card>
          <b-row class="d-flex justify-content-between mb-2">
            <b-col cols="12" sm="6" md="4">
              <span>Show</span>
              <label class="d-inline-flex align-items-center">
                <b-form-select
                  v-model="pageSize"
                  size="sm"
                  :options="[10, 25, 50, 100, 200]"
                  class="ml-3"
                  @change="reLoad"
                >
                </b-form-select>
              </label>
              <span class="ml-2">entries</span>
            </b-col>
            <b-col cols="12" sm="6" md="4">
              <b-input-group>
                <template #prepend>
                  <b-input-group-text>
                    <i class="fas fa-search"></i>
                  </b-input-group-text>
                </template>
                <b-form-input
                  placeholder="Search"
                  v-model="search"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-table
                responsive
                :items="
                  items.map((it, index) => ({
                    ...it,
                    index: firstRowOnPage + index,
                  }))
                "
                class="table-centered table-nowrap"
                :empty-text="'No data found'"
                :show-empty="!items || (items && items.length == 0)"
                :bordered="true"
                :filter="search"
                align="center"
                :perPage="pageSize"
                :fields="fields"
                @filtered="onFiltered"
              >
                <template #cell(id)="row">
                  <router-link
                    :to="'/consumer-logs/' + row.item.id"
                    target="_blank"
                  >
                    {{ row.value }} <i class="bx bx-link-external"></i>
                  </router-link>
                </template>
                <template #cell(exception)="row">
                  <span
                    class="d-inline-block text-truncate"
                    style="max-width: 300px"
                  >
                    <a
                      href="#"
                      class="text-decoration-none"
                      @click="
                        onClickModalMoreDetail(
                          row.item.exception,
                          'lg',
                          'Exception Detail',
                          'text'
                        )
                      "
                    >
                      {{ row.item.exception | exceptionFormat }}
                    </a>
                  </span>
                  <span class="d-inline-block text-truncate">
                    <a
                      href="#"
                      class="text-decoration-none"
                      @click="
                        onClickModalMoreDetail(
                          row.item.exception,
                          'lg',
                          'Exception Detail',
                          'text'
                        )
                      "
                    >
                      <i class="bx bx-show"></i>
                    </a>
                  </span>
                </template>
                <template #cell(message)="row">
                  <span
                    class="d-inline-block text-truncate"
                    style="max-width: 300px"
                  >
                    <a
                      href="#"
                      class="text-decoration-none"
                      @click="
                        onClickModalMoreDetail(
                          row.item.message,
                          'xl',
                          'Message Detail',
                          'json'
                        )
                      "
                    >
                      {{ row.item.message }}
                    </a>
                  </span>
                  <span
                    class="d-inline-block text-truncate"
                    style="max-width: 150px"
                  >
                    <a
                      href="#"
                      class="text-decoration-none"
                      @click="
                        onClickModalMoreDetail(
                          row.item.message,
                          'xl',
                          'Message Detail',
                          'json'
                        )
                      "
                    >
                      <i class="bx bx-show"></i>
                    </a>
                  </span>
                </template>
                <template #cell(status)="row">
                  <b-button
                    v-if="row.value === 'None' && row.item.exchange"
                    :disabled="!row.item.exchange"
                    pill
                    variant="warning"
                    @click="onClickResend(row.item.id)"
                  >
                    <i class="fas fa-paper-plane"></i>ส่งอีกครั้ง
                  </b-button>
                  <b-button
                    disabled
                    v-if="row.value === 'Resent'"
                    pill
                    variant="success"
                  >
                    <i class="fas fa-check"></i>
                    {{
                      row.item.status === "Resent" ? "ส่งแล้ว" : row.item.status
                    }}
                  </b-button>
                  <i
                    class="h2 fas fa-exclamation-circle mb-0 text-warning"
                    id="tooltip-button-variant"
                    v-if="!row.item.exchange"
                    v-b-tooltip.hover
                    title="ไม่สามารถส่งได้ เนื่องจากไม่มี Exchange"
                  >
                  </i>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="4">
              <div style="position: relative; top: 7px">
                Showing {{ firstRowOnPage }} to {{ lastRowOnPage }} of
                {{ totalRecords }} entries
              </div>
            </b-col>
            <b-col lg="8">
              <b-pagination
                :total-rows="totalRecords"
                :per-page="pageSize"
                v-model="pageNo"
                @change="onClickPagination($event)"
                class="pagination pagination-rounded justify-content-end mb-2"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <modal-more-detail
      v-if="modalMoreDetail.isShow"
      :content="modalMoreDetail.content"
      :size="modalMoreDetail.size"
      :contentType="modalMoreDetail.contentType"
      :title="modalMoreDetail.title"
      v-model="modalMoreDetail.isShow"
    ></modal-more-detail>
  </Layout>
</template>

<script>
// load components
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// load config
import appConfig from "@/app.config";

// load package
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Multiselect from "vue-multiselect";

//load helper
import { FormatQty } from "@/helpers/utils/format-qty.js";
import { FormatDate, FormatDateTime } from "@/helpers/utils/format-date.js";
import ModalMoreDetail from "../../../components/consumer-logs/modal-more-detail.vue";
import core from "@/helpers/client";
import { ToISOString } from "@/helpers/utils/format-date.js";

const axios = require("axios").default;

export default {
  name: "consumer_logs",
  page: {
    title: "Consumer Log",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Loading,
    DatePicker,
    Multiselect,
    ModalMoreDetail,
  },
  data() {
    return {
      isLoading: true,
      fullPage: true,
      title: "Consumer Log Panel",
      itemsPageHeader: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Consumer Log",
          active: true,
        },
      ],
      filter: {
        keyword: "",
        Status: [],
        Exchange: "",
        DateTime: null,
        sort: null,
        dateFrom: null,
        dateTo: null,
      },
      allSelected: false,
      indeterminate: false,
      items: [],
      pageNo: 1,
      pageSize: 25,
      hasNextPage: false,
      hasPreviousPage: false,
      totalPages: 0,
      totalRecords: 0,
      search: "",
      fields: [
        {
          key: "index",
          formatter: (value, key, item) => FormatQty(value ? value : 0),
          label: "No",
          thStyle: "width:80px",
          sortable: true,
        },
        {
          key: "id",
          formatter: (value, key, item) =>
            value ? `...${value.substring(value.length - 4)}` : "",
          label: "Id",
          thStyle: "width:80px",
          sortable: true,
        },
        {
          key: "exchange",
          label: "Type",
          thStyle: "width:80px",
          formatter: (value, key, item) => this.namingType(value),
          sortable: true,
        },
        {
          key: "exception",
          label: "Exception",
          thStyle: "width: 300px",
          sortable: true,
        },
        {
          key: "message",
          label: "Message",
          thStyle: "width: 300px",
          sortable: true,
        },
        {
          key: "dateTime",
          label: "DateTime",
          thStyle: "width: 150px",
          formatter: (value, key, item) => FormatDateTime(value),
          sortable: true,
        },
        {
          key: "status",
          label: "Resend",
          thStyle: "width:80px",
          formatter: (value, key, item) => value || "None",
          sortable: true,
        },
      ],
      modalMoreDetail: {
        isShow: false,
        content: "",
        contentType: "text",
        title: "",
        size: "lg",
      },
      exchangeTypes: [],
    };
  },
  created() {
    this.onLoad();
  },
  methods: {
    async onLoad() {
      // load consumer log
      await this.getConsumerLogAsync();
      await this.getExchangeTypesAsync();
      this.isLoading = false;
    },
    async reLoad() {
      this.isLoading = true;
      await this.getConsumerLogAsync();
      this.isLoading = false;
    },
    async getConsumerLogAsync() {
      this.isLoading = true;
      // console.log(this.filter);
      let params = new URLSearchParams();
      if (this.filter.keyword) {
        params.append("keyword", this.filter.keyword);
      }
      if (this.filter.Status || this.filter.Status.length > 0) {
        this.filter.Status.forEach((element) => {
          params.append("status", element);
        });
      }
      if (this.filter.Exchange) {
        params.append("exchange", this.filter.Exchange);
      }
      if (this.filter.dateFrom && this.filter.dateTo) {
        params.append("datefrom", this.filter.dateFrom);
        params.append("dateto", this.filter.dateTo);
      }
      if (this.pageNo) {
        params.append("pageno", this.pageNo);
      }
      if (this.pageSize) {
        params.append("pagesize", this.pageSize);
      }
      if (this.filter.sort) {
        params.append("sort", this.filter.sort);
      }

      const res = await core.fetch(
        `${process.env.VUE_APP_BASE_API_CONSUMER_LOG}/api/v1/ConsumerLog`,
        params
      );
      // console.log(res);
      if (res.status === 200) {
        this.items = res.data.items;
        this.pageNo = res.data.pageNo;
        this.pageSize = res.data.pageSize;
        this.hasNextPage = res.data.hasNextPage;
        this.hasPreviousPage = res.data.hasPreviousPage;
        this.totalPages = res.data.totalPages;
        this.totalRecords = res.data.totalRecords;
        this.isLoading = false;
      }
    },
    async getExchangeTypesAsync() {
      const res = await core.fetch(
        `${process.env.VUE_APP_BASE_API_CONSUMER_LOG}/api/v1/ConsumerLog/exchangetypes`
      );
      if (res.status === 200) {
        // console.log(res);
        const exchangeTypes = res.data.filter((it) => !!it);
        this.exchangeTypes = exchangeTypes;
      }
    },
    namingType(val) {
      if (!val) return val;
      const cutDomainEventSourcing = val.split(":")[0]; // cut DomainEventSourcing
      if (!cutDomainEventSourcing) return val;
      const cutEvent = cutDomainEventSourcing.split(".");
      cutEvent.splice(0, 2);
      if (!cutEvent) return val;

      return cutEvent.join("-");
      // return `555${val}`;
    },
    toggleAll(checked) {
      this.filter.Status = checked ? ["Resent", "None"].slice() : [];
    },
    async onClickPagination(pageNo) {
      this.pageNo = pageNo;
      this.reLoad();
    },
    async onFiltered(filteredItems) {
      this.totalPages = filteredItems.length;
    },
    onClickModalMoreDetail(content, size, title, contentType) {
      this.modalMoreDetail = {
        isShow: true,
        content: content,
        contentType: contentType,
        title: title,
        size: size,
      };
    },
    async onClickResend(id) {
      const res = await core.create(
        `${process.env.VUE_APP_BASE_API_CONSUMER_LOG}/api/v1/ConsumerLog/${id}/RabbitMQ`,
        null
      );
      if (res.status === 200) {
        this.items = this.items.map((it) =>
          it.id === id ? { ...it, status: "Resent" } : it
        );
      }
    },
    async onSearchClicked() {
      // console.log(this.filter);
      this.getConsumerLogAsync();
    },
    onResetClicked() {
      const filter = {
        keyword: "",
        Status: [],
        Exchange: "",
        DateTime: null,
        sort: null,
        dateFrom: null,
        dateTo: null,
      };
      this.filter = filter;
    },
    onDatePickerConfirm() {
      this.filter.dateFrom = ToISOString(new Date(this.filter.DateTime[0]));
      this.filter.dateTo = ToISOString(new Date(this.filter.DateTime[1]));
    },
    onDatePickerClear() {
      this.filter.DateTime = null;
      this.filter.dateFrom = null;
      this.filter.dateTo = null;
    },
  },
  watch: {
    "filter.Status"(newValue, oldValue) {
      // Handle changes in individual flavour checkboxes
      if (newValue.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newValue.length === 2) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    },
  },
  computed: {
    firstRowOnPage() {
      return 1 + (this.pageNo - 1) * this.pageSize;
    },
    lastRowOnPage() {
      return this.firstRowOnPage + this.items.length - 1;
    },
  },
  filters: {
    exceptionFormat: (value) => {
      if (!value) return "";
      const val = value.split(":");
      val.shift();
      return val.join(":");
    },
  },
};
</script>

<style scoped></style>
